import { HealthMetrics } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';

export const initialHealthMetricsState: HealthMetrics = {
  delivery: {
    overall: 0,
    history: [
      {
        date: 0,
        value: 0,
      },
    ],
  },
  demand: {
    overall: 0,
    history: [
      {
        date: 0,
        value: 0,
      },
    ],
  },
};
